
























import VueOptions from '@utils/VueOptions'
import TagBar from '@ui/TagBar'
import TreeSelector from '@ui/TreeSelector'

settings =
  name: 'FormFieldProhibitedCategories'

  vue:
    props: ['value', 'errors']

    components: {
      TagBar,
      TreeSelector,
    }

    data: ->
      selectedCategories: []
      categories: @value || {}

    computed:
      prohibitedCategories: ->
        Object.values(@categories).filter((c) => c.prohibited).map((c) => c.category)

      categoryOptions: ->
        mapping = @$store.marketplace?.brand?.categories || {}
        tree = @$store.marketplace?.brand?.category_tree || {}
        tree.other ||= "Other" # auto add as a top level category
        @jsonToElementUICascader tree, mapping

      actionsForCategories: ->
        select: @selectCategories

      actionsForTagBar: ->
        onRemove: @removeCategory

      optionsForTagBar: ->
        {
          bar: {
            theme: 'danger',
            max: 5
          },
          tag: {
            theme: 'danger',
            maxLength: 12
          }
        }

    methods:
      hiAddCategories: ->
        category = @selectedCategories.pop()
        @categories = { ...@categories, [category]: { category, prohibited: true, sponsors: [] } }
        @selectedCategories = []
        @inputChanged()

      selectCategories: (categories) ->
        @selectedCategories = categories

      removeCategory: (category) ->
        categories = { ...@categories }
        delete categories[category]
        @categories = categories
        @inputChanged()

      inputChanged: ->
        @$emit 'input', @categories
        @$emit 'change', @categories

export default VueOptions.vue settings
